import { Game } from 'chessboard/model/game/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { JCEColorCodes } from 'chessboard/plugins/markings/model/convert-marking-from-jce';

/**
 * Convert markings to a collection
 */
export function convertMarkingsToCollection(
  markings: Markings.KeyedModel[],
): Game.Node.Marking.Collection {
  const markingCollection: Game.Node.Marking.Collection = {
    [Game.Node.Marking.Types.Arrow]: {},
    [Game.Node.Marking.Types.CustomItem]: {},
    [Game.Node.Marking.Types.Effect]: {},
    [Game.Node.Marking.Types.Square]: {},
  };

  const mappedMarkings = markings.map((item) => ({
    markingType: item.type === 'highlight' ? 'square' : item.type,
    key: item.data.square ?? `${item.data.from}${item.data.to}`,
    color: JCEColorCodes.Default,
    ...item.data,
  }));

  return mappedMarkings.reduce((result, item) => {
    const { key, markingType } = item;

    result[markingType][key] = item;

    return result;
  }, markingCollection);
}
